import { useState, useEffect, useRef } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import Metatag from 'app/components/metaTag';
import { SERVICES_PAGE } from 'app/helpers/apiEndpoint';
import REQUEST from 'app/helpers/http.service';
import 'styles/Home.module.css';
import WriteGetInTouch from 'app/components/writetous/WriteGetInTouch';
import HireScheduleTalent from 'app/components/common/HireScheduleTalent';
import NewHeroSectionCenter from 'app/components/common/NewHeroSectionCenter';
import ScrollLink from 'app/components/Services/ScrollLink';
import Richtext from 'app/components/Services/Richtext';
import WriteCTA from 'app/components/writetous/WriteCTA';
import DevopsSoftWare from 'app/components/warehouse/DevopsSoftWare';
import OurClient from 'app/components/common/OurClient';

export default function Services({ res }) {
  const [modalScheduleCall, setModalScheduleCall] = useState(false);
  const ref = useRef();
  const { serviceData } = JSON.parse(res);
  const { asPath } = useRouter();
  const router = useRouter();
  const canonicalUrl = (
    `${process.env.NEXT_PUBLIC_BASE_URL}` +
    (router.asPath === '/' ? '' : router.asPath)
  ).split('?')[0];

  const slugify = str =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  useEffect(() => {
    if (typeof document !== 'undefined') {
      const blogContentRef = ref.current;
      const array = blogContentRef.querySelectorAll('h6');
      for (let heading of array) {
        heading.setAttribute('id', slugify(heading.innerText));
      }
    }
  }, []);
  const handleScroll = (blogContentRef, e) => {
    const el = document.getElementsByClassName('table_content');
    const sideBar = document.getElementById('innerScroll');
    let element = document.getElementById(`${blogContentRef}`);

    for (let i = 0; i < el.length; i++) {
      el[i].classList.remove('active-link');
    }

    e.target.classList.add('active-link');
    let textHeight = e.target.clientHeight;

    let currentPos = e.target.offsetTop - textHeight;
    sideBar.scrollTo({ top: currentPos, behavior: 'smooth' });
    element.scrollIntoView({
      block: 'center',
      behavior: 'smooth',
    });
  };

  if (serviceData?.error) {
    return <div>{serviceData?.error}</div>;
  }

  return (
    <div className="md:pt-[80px] pt-[70px] roboto bg-[#000815]">
      <Head>
        <title>{serviceData?.seoMeta && serviceData?.seoMeta?.metaTitle}</title>
        <meta
          name="description"
          content={
            serviceData?.seoMeta && serviceData?.seoMeta?.metaDescription
          }
        />
        <meta
          property="og:title"
          content={serviceData?.seoMeta && serviceData?.seoMeta?.metaTitle}
        />
        <meta
          property="og:description"
          content={
            serviceData?.seoMeta && serviceData?.seoMeta?.metaDescription
          }
        />
        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_BASE_URL}${asPath}`}
        />

        <Metatag
          content={
            serviceData?.seoMeta &&
            serviceData?.seoMeta?.metaImage?.data?.attributes?.url
          }
          pageUrl={canonicalUrl}
        />
        <link rel="canonical" href={canonicalUrl} />
      </Head>

      <NewHeroSectionCenter
        hero={serviceData?.HeroSection}
        setModalCall={setModalScheduleCall}
      />
      <div className="bg-[linear-gradient(90deg,_#000815_0%,_#010D24_100%)]">
        <ScrollLink
          serviceLink={serviceData?.Services}
          handleScroll={handleScroll}
        />
      </div>
      <div ref={ref}>
        <Richtext richtext={serviceData?.ServiceDescription1} color={'#fff'} />
        {serviceData?.Partner && (
          <WriteCTA
            Pricing={serviceData?.Partner}
            setModalCall={setModalScheduleCall}
          />
        )}
        <Richtext richtext={serviceData?.TechnologyWeDeals} color={'#fff'} />
      </div>
      {serviceData?.Transform && (
        <WriteCTA
          Pricing={serviceData?.Transform}
          setModalCall={setModalScheduleCall}
        />
      )}
      {serviceData?.Technologies && (
        <div className="xl:mt-[75px] mt-[35px]">
          <DevopsSoftWare
            data={serviceData?.Technologies}
            isWeb={'Front-End Development'}
            ishome={true}
            isHDcolor={'#ffffff'}
            // isStaff={true}
          />
        </div>
      )}
      {serviceData?.Awards && (
        <OurClient ClientSucess={serviceData?.Awards} isColor={'transparent'} />
      )}
      <WriteGetInTouch isStaff={true} ishome={true} isNewHome={true} />
      {modalScheduleCall && (
        <HireScheduleTalent
          ButtonText={modalScheduleCall}
          setIsOpen={setModalScheduleCall}
        />
      )}
    </div>
  );
}
export async function getStaticProps() {
  const [serviceData] = await Promise.all([
    REQUEST({
      method: 'GET',
      url: SERVICES_PAGE,
    }),
  ]);
  const res = JSON.stringify({
    serviceData: serviceData?.data?.data?.attributes,
  });
  return {
    props: {
      res,
    },
  };
}
